var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18555 0.205078L9.16992 4.18945C9.30664 4.32617 9.375 4.49219 9.375 4.6875C9.375 4.88281 9.30664 5.04883 9.16992 5.18555L8.49609 5.83008C8.35937 5.9668 8.19336 6.03516 7.99805 6.03516C7.80273 6.03516 7.63672 5.9668 7.5 5.83008L4.6875 3.01758L1.875 5.83008C1.73828 5.9668 1.57227 6.03516 1.37695 6.03516C1.18164 6.03516 1.01562 5.9668 0.878906 5.83008L0.205078 5.18555C0.0683593 5.04883 -1.00741e-07 4.88281 -1.17816e-07 4.6875C-1.34891e-07 4.49219 0.0683592 4.32617 0.205078 4.18945L4.18945 0.205079C4.32617 0.0683598 4.49219 4.26869e-07 4.6875 4.09794e-07C4.88281 3.9272e-07 5.04883 0.0683598 5.18555 0.205078Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.8f5081ae2884e158c823a2508a1b2848.svg";
export { ForwardRef as ReactComponent };